import { ResponsiveBar } from "@nivo/bar";
import { useTranslation } from "react-i18next";

import { InvestmentGraphic } from "components/InvestmentGraphicNew";

import { Typography } from "shared/ui/components/Typography";

import styles from "./TaxSavingsChart.module.scss";

const _renderInfoPopover = ({ info }: { info: any }) => {
  return (
    <div className={styles.popover}>
      <Typography variant="bodyS" weight="light">
        {info?.section1}
      </Typography>
      {info?.section2 && (
        <Typography
          variant="bodyS"
          weight="light"
          className={styles.popoverSection}
        >
          {info?.section2}
        </Typography>
      )}
    </div>
  );
};

const TaxSavingsChart = ({
  variant,
  taxSavingsConclusion,
}: {
  variant: string;
  taxSavingsConclusion: any;
}) => {
  const { t } = useTranslation();

  return (
    <InvestmentGraphic
      variant={variant}
      descriptionVariant={variant}
      title={t("calculator_pro_page.tax_savings_chart.title")}
      price={taxSavingsConclusion.price}
      caption={taxSavingsConclusion.caption}
      description={taxSavingsConclusion.description}
      details={taxSavingsConclusion.details}
      infoPopover={_renderInfoPopover({ info: taxSavingsConclusion.info })}
    >
      <div className={styles.chart}>
        <ResponsiveBar
          data={taxSavingsConclusion.chartData}
          indexBy="id"
          enableLabel
          enableGridY={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          axisBottom={null}
          axisLeft={null}
          colors={({ id, data }) => {
            return String(data[`${id}Color`]);
          }}
          labelPosition="end"
          labelOffset={10}
          labelTextColor="#131618"
          label={(labelItem: any) => {
            return labelItem.data.chartItem;
          }}
          tooltip={() => <></>}
          margin={{ top: 15, right: 0, bottom: 0, left: 0 }}
          theme={{
            labels: {
              text: {
                fontSize: 8,
              },
            },
          }}
        />
      </div>
    </InvestmentGraphic>
  );
};

export default TaxSavingsChart;
